import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePutApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { LiteSample, LiteSampleForm, LiteSampleSearchForm } from 'entities/lite_sample'

type LiteSamplesResponse = PagingResponse & {
    results: LiteSample[]
}

export function useFetchLiteSamplesApi(searchForm: Form<LiteSampleSearchForm>): IndexApiSet<LiteSamplesResponse> & { execute: () => void } {
    const apiPath = 'lite_samples/'
    const api = useIndexApi<LiteSamplesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

type LiteSampleResponse = BaseResponse & LiteSample

export function useFetchLiteSampleApi(): ApiSet<LiteSampleResponse> & { execute: (id: number) => void } {
    const api = useShowApi<LiteSampleResponse>(new CraifHttpClient(), {
        initialResponse: {} as LiteSampleResponse,
    })

    const execute = (id: number): void => {
        const apiPath = `lite_samples/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export function usePutLiteSampleApi(): ApiSet<BaseResponse> & { execute: (form: Form<LiteSampleForm>) => void } {
    const apiSet = usePutApi<BaseResponse, LiteSampleForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<LiteSampleForm>) => {
        const apiPath = `lite_samples/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutLiteSamplesApi(): ApiSet<BaseResponse> & { execute: (form: Form<LiteSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, LiteSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<LiteSampleForm[]>) => {
        const apiPath = `lite_samples/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
export function usePutLiteSampleResultStatusApi(): ApiSet<BaseResponse> & { execute: (form: Form<LiteSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, LiteSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<LiteSampleForm[]>) => {
        const apiPath = `lite_samples/update_result_status/`
        
        form.object.forEach((sample) => {
            delete sample.resultCheckedUser
        })
        
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function usePutLiteSampleResultConfirmApi(): ApiSet<BaseResponse> & { execute: (form: Form<LiteSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, LiteSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<LiteSampleForm[]>) => {
        const apiPath = `lite_samples/update_result_confirm/`

        form.object.forEach((sample) => {
            delete sample.resultCheckedUser
        })

        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}